import React, { FC } from 'react';
import { usePopupContext } from '../../contexts/Settings';
import SkeletonOfferGrid from './SkeletonOfferGrid';
import SkeletonOfferTree from './SkeletonOfferTree';
import { isGridLayout } from '../../types';

type SkeletonOfferProps = {
  indexInOffers?: number;
  offerCount: number;
};

const SkeletonOffer: FC<SkeletonOfferProps> = ({
  indexInOffers,
  offerCount,
}) => {
  const { settings } = usePopupContext();

  return isGridLayout(settings) ? (
    <SkeletonOfferGrid />
  ) : (
    <SkeletonOfferTree indexInOffers={indexInOffers} offerCount={offerCount} />
  );
};

export default SkeletonOffer;
